import * as React from 'react';
import InputMask from 'react-input-mask';
import cx from 'classnames';

import * as styles from './styles.css';

export interface IMaskedInput {
  value: string;
  invalid: boolean;
  size?: 'large' | 'small';
  onChange(e: React.ChangeEvent<HTMLInputElement>): void;
  onBlur?(e: React.ChangeEvent<HTMLInputElement>): void;
  onFocus?(e: React.ChangeEvent<HTMLInputElement>): void;
}

export const MaskedInput: React.FC<IMaskedInput> = ({ value, invalid, size, onChange, onFocus, onBlur }) => {
  return (
    <InputMask
      mask="+7 \(999)\ 999 99 99"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      maskPlaceholder={null}
    >
      <div className={cx(styles['input-wrapper'], invalid && styles['input-wrapper--invalid'])}>
        <input
          type="phone"
          className={cx(styles['input'], styles[`input-${size || 'large'}`])}
          placeholder="+7 "
          value={value}
          onChange={onChange}
        />
      </div>
    </InputMask>
  );
};
